(function() { window.GUID_4fbfc567_744c_40a6_aeb4_5a66d7d5d930 = { getGuid: function() { return "4fbfc567-744c-40a6-aeb4-5a66d7d5d930"; } }; })();
var CS;
(function (CS) {
    class DOB {
        ShowDOBPopupDateIsString(dobDate, referenceDate) {
            var newDate = this.ConvertDateStrToDate(dobDate);
            var newRefDate = this.ConvertDateStrToDate(referenceDate);
            return this.ShowDOBPopup(newDate, newRefDate);
        }
        ConvertDateStrToDate(dateStr) {
            let yearIndex = 0;
            let monthIndex = 0;
            let dayIndex = 0;
            let splitterChar = '-';
            let dateFormat = JSRess.Date;
            if (dateFormat.indexOf("/") > -1) {
                splitterChar = "/";
            }
            let splittedParts = dateFormat.split(splitterChar);
            for (var i = 0; i < splittedParts.length; i++) {
                var currentPart = splittedParts[i];
                if (currentPart == "yyyy") {
                    yearIndex = i;
                }
                else if (currentPart == "MM") {
                    monthIndex = i;
                }
                else if (currentPart == "dd") {
                    dayIndex = i;
                }
            }
            var splittedDate = dateStr.split(splitterChar);
            return new Date(parseInt(splittedDate[yearIndex], 10), parseInt(splittedDate[monthIndex], 10) - 1, parseInt(splittedDate[dayIndex], 10));
        }
        ShowDOBPopup(dobDate, referenceDate) {
            if (referenceDate == null) {
                //J'enleve les seconds minutes, etc pour la reference, sinon, melant :)
                var tempNewDate = new Date();
                referenceDate = new Date(tempNewDate.getFullYear(), tempNewDate.getMonth(), tempNewDate.getDate());
            }
            this.ReferenceDate = referenceDate;
            var me = this;
            var dobPopup = new CompuSport.Controls.Popup();
            var params = { PopupId: 'DOBPopup', Buttons: "Ok,Cancel" };
            dobPopup.OnContentLoaded = function () {
                var ageDropDown = dobPopup.Content.find(".AgeSelector");
                var dobDropDowns = dobPopup.Content.find(".DOBSelectorContainer");
                ageDropDown.on('change', function (e) {
                    var newAge = parseInt($(this).val(), 10);
                    var newDOB = me.GetDateFromAge(newAge);
                    me.SetNewDOB(dobDropDowns, newDOB);
                });
                dobDropDowns.on('change', function (e) {
                    var newDate = me.SelectorToDate(dobDropDowns);
                    var newAge = me.GetAgeFromDate(newDate);
                    ageDropDown.val(newAge);
                });
            };
            dobPopup.Show(me.GetDOBControl(dobDate), params);
            dobPopup.OnButtonClicked = function (button, buttonValue) {
                if (buttonValue == "Ok") {
                    var newDate = me.SelectorToDate(dobPopup.Content);
                    var newDateString = me.SelectorToDateString(dobPopup.Content);
                    var newAge = me.GetAgeFromDate(newDate);
                    me.OnDOBAccepted(newDate, newDateString, newAge);
                }
            };
        }
        GetDOBControl(dobDate) {
            var day = 1;
            var month = 1;
            var year;
            var actualYear = new Date().getFullYear();
            var nbYears = 100;
            var startYear = actualYear - nbYears;
            var endYear = nbYears + startYear;
            year = startYear + nbYears / 2;
            if (dobDate != null) {
                year = dobDate.getFullYear();
                month = dobDate.getMonth() + 1;
                day = dobDate.getDate();
            }
            //##############################################################################
            //######################## Day part ############################################
            //##############################################################################
            var nbDays = 31;
            var daySel = "";
            daySel += "<select class='DOBD'>";
            for (let dayIndex = 1; dayIndex <= nbDays; dayIndex++) {
                let isSelectedStr = "";
                if (dayIndex == day) {
                    isSelectedStr = ' selected="selected"';
                }
                daySel += '<option' + isSelectedStr + ' value="' + dayIndex + '">' + dayIndex + '</option>';
            }
            daySel += "</select>";
            //##############################################################################
            //######################## Month part ############################################
            //##############################################################################
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var nbMonths = months.length;
            var monthSel = "";
            monthSel += "<select class='DOBM'>";
            for (let monthIndex = 1; monthIndex <= nbMonths; monthIndex++) {
                let isSelectedStr = "";
                if (monthIndex == month) {
                    isSelectedStr = ' selected="selected"';
                }
                monthSel += '<option' + isSelectedStr + ' value="' + monthIndex + '">' + months[monthIndex - 1] + '</option>';
            }
            monthSel += "</select>";
            //##############################################################################
            //######################## Year part ############################################
            //##############################################################################
            var yearSel = "";
            yearSel += "<select class='DOBY'>";
            for (let yearIndex = startYear; yearIndex <= endYear; yearIndex++) {
                let isSelectedStr = "";
                if (yearIndex == year) {
                    isSelectedStr = ' selected="selected"';
                }
                yearSel += '<option' + isSelectedStr + ' value="' + yearIndex + '">' + yearIndex + '</option>';
            }
            yearSel += "</select>";
            var html = "";
            /*##############   AGE   ##############*/
            var age;
            if (dobDate != null) {
                age = this.GetAgeFromDate(dobDate);
            }
            //yearIndex = 10;
            var ageSel = '';
            ageSel += "<select class='AgeSelector'>";
            for (let yearIndex = 1; yearIndex <= nbYears; yearIndex++) {
                let isSelectedStr = "";
                if (yearIndex == age) {
                    isSelectedStr = ' selected="selected"';
                }
                ageSel += '<option' + isSelectedStr + ' value="' + yearIndex + '">' + yearIndex + '</option>';
            }
            ageSel += "</select>";
            html += "<div class='AgeSelectorContainer'><table>";
            html += "<thead><tr>";
            html += "<th>Age</th>";
            html += "</tr></thead>";
            html += "<tbody><tr>";
            html += "<td>" + ageSel + "</td>";
            html += "</tr></tbody>";
            html += "</table></div>";
            html += "<div class='DivOr'> OR </div>";
            /*##############   DOB   ##############*/
            html += "<div class='DOBSelectorContainer'><table>";
            html += "<thead><tr><th colspan='3'>Date of birth</th></tr>";
            html += "<tr>";
            html += "<th>Month</th>";
            html += "<th>Day</th>";
            html += "<th>Year</th>";
            html += "</tr></thead>";
            html += "<tbody><tr>";
            html += "<td>" + monthSel + "</td>";
            html += "<td>" + daySel + "</td>";
            html += "<td>" + yearSel + "</td>";
            html += "</tr></tbody>";
            html += "</table></div>";
            return html;
        }
        SetNewDOB(dobSelectorContainer, date) {
            var DOBD = dobSelectorContainer.find(".DOBD");
            var DOBM = dobSelectorContainer.find(".DOBM");
            var DOBY = dobSelectorContainer.find(".DOBY");
            DOBD.val(date.getDate());
            DOBM.val(date.getMonth() + 1);
            DOBY.val(date.getFullYear());
        }
        SelectorToDateString(container) {
            var daySelector = container.find('.DOBD').val();
            var monthSelector = container.find('.DOBM').val();
            var yearSelector = container.find('.DOBY').val();
            if (daySelector.length == 1) {
                daySelector = "0" + daySelector;
            }
            if (monthSelector.length == 1) {
                monthSelector = "0" + monthSelector;
            }
            if (yearSelector.length == 1) {
                yearSelector = "0" + yearSelector;
            }
            let returnStrDateFormat = JSRess.Date;
            return returnStrDateFormat.replace("yyyy", yearSelector).replace("MM", monthSelector).replace("dd", daySelector);
            //return yearSelector + "-" + monthSelector + "-" + daySelector;
        }
        SelectorToDate(container) {
            var daySelector = container.find('.DOBD').val();
            var monthSelector = container.find('.DOBM').val();
            var yearSelector = container.find('.DOBY').val();
            return new Date(parseInt(yearSelector, 10), parseInt(monthSelector, 10) - 1, parseInt(daySelector, 10));
        }
        GetAgeFromDate(date) {
            var age = this.ReferenceDate.getFullYear() - date.getFullYear();
            if (this.ReferenceDate.getMonth() < date.getMonth() || (this.ReferenceDate.getMonth() == date.getMonth() && this.ReferenceDate.getDate() < date.getDate())) {
                age--;
            }
            return age;
        }
        GetDateFromAge(age) {
            var diff = this.ReferenceDate.getFullYear() - age;
            return new Date(diff, this.ReferenceDate.getMonth(), this.ReferenceDate.getDate());
        }
    }
    CS.DOB = DOB;
})(CS || (CS = {}));

//# sourceMappingURL=DOB.js.map
